import { Component, Input, OnInit } from '@angular/core';
import { AttributeValue, EditedAttributeValues, OptionDefinition } from '../../../../../models/section-definition.model';
import { AttributeValidationError } from '../attribute-number-edit-row/attribute-number-edit-row.component';

export function getDropdownValidationError(
  attr: AttributeValue,
  selectedIds: number[],
): AttributeValidationError | null {
  return selectedIds.length === 0 && attr.isRequired ? { key: 'COMMON.ATTRIBUTE_VALIDATION.REQUIRED' } : null;
}

export function isSameOptionIds(a: number[], b: number[]): boolean {
  return a.length === b.length && a.every((id) => b.includes(id));
}

@Component({
  selector: 'lib-attribute-dropdown-edit-row',
  standalone: false,
  templateUrl: './attribute-dropdown-edit-row.component.html',
  styleUrls: ['./attribute-dropdown-edit-row.component.scss'],
})
export class AttributeDropdownEditRowComponent implements OnInit {
  @Input() attributeValue!: AttributeValue;
  @Input() editedValues: EditedAttributeValues = {};
  options: OptionDefinition[] = [];
  selectedIds: number[] = [];
  isSingle: boolean = false;
  error: AttributeValidationError | null = null;

  ngOnInit(): void {
    const id = this.attributeValue.attributeDefinitionId;
    // Same as mobile: a dropdown is single-select only when isSingleType is true.
    this.isSingle = this.attributeValue.isSingleType === true;
    this.options = [...(this.attributeValue.optionDefinitions ?? [])].sort((a, b) => a.displayOrder - b.displayOrder);
    this.selectedIds = [
      ...(((id in this.editedValues ? this.editedValues[id] : this.attributeValue.selectedOptionIds) as number[] | undefined) ?? []),
    ];
    this.validate(this.selectedIds);
  }

  onSingleChange(optionId: number | null) {
    this.setSelectedIds(optionId == null ? [] : [optionId]);
  }

  onToggle(optionId: number) {
    this.setSelectedIds(
      this.selectedIds.includes(optionId)
        ? this.selectedIds.filter((x) => x !== optionId)
        : [...this.selectedIds, optionId],
    );
  }

  private setSelectedIds(ids: number[]) {
    this.selectedIds = ids;
    this.editedValues[this.attributeValue.attributeDefinitionId] = ids;
    this.validate(ids);
  }

  // Unchanged values are not validated, except empty ones, so a required field that is still empty shows an error.
  private validate(ids: number[]) {
    this.error = ids.length > 0 && isSameOptionIds(ids, this.attributeValue.selectedOptionIds ?? [])
      ? null
      : getDropdownValidationError(this.attributeValue, ids);
  }
}
